import { createSelector } from "@ngrx/store";
import { selectUser } from "../root.selectors";
import { UserState } from "./user.state";

export const selectUserToken = createSelector(
    selectUser, 
    (userInfo: UserState) => {
        return userInfo.userToken
    }
)